/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left-otg-green': {
    width: 9,
    height: 13,
    viewBox: '0 0 9 13',
    data: '<path pid="0" d="M7.693 11.886L2.307 6.5l5.386-5.386" _stroke="#37A48B" stroke-width="2" stroke-miterlimit="10"/>'
  }
})
